export default __webpack_public_path__ + "static/media/queue.56c64058.png";